import React, { useEffect, useState, forwardRef } from 'react';

const CustomImageBox = forwardRef(({ onChange, imageUrl, label, name, maxSize, hint, editLabel, ...props }, ref) => {
    const [imageSrc, setImageSrc] = useState(imageUrl);
    const [sizeError, setSizeError] = useState('');
    const inputId = `file-input-${name || 'default'}`;

    useEffect(() => {
        setImageSrc(imageUrl);
    }, [imageUrl]);

    const handleImageChange = (event) => {
        const file = event.target.files?.[0];
        if (file) {
            if (maxSize && file.size > maxSize) {
                const limitLabel = maxSize >= 1024 * 1024
                    ? `${(maxSize / (1024 * 1024)).toFixed(0)} MB`
                    : `${Math.round(maxSize / 1024)} KB`;
                setSizeError(`File is too large. Maximum allowed size is ${limitLabel}.`);
                onChange(event, '', '');
                event.target.value = '';
                return;
            }
            setSizeError('');
            const objectUrl = URL.createObjectURL(file);
            setImageSrc(objectUrl);
            onChange(event, file, objectUrl);
        } else {
            setSizeError('');
            onChange(event, '', '');
            setImageSrc(imageUrl);
        }
    };

    return (
        <div {...props} ref={ref}>
            <label htmlFor={inputId} className="form-label">{label}</label>
            <div className="position-relative">
                <div className="upload-options">
                    <label htmlFor={inputId}>
                        {editLabel && <span className="image-edit-label">{editLabel}</span>}
                        <input
                            name={name}
                            type="file"
                            accept=".png, .jpg, .jpeg, .webp"
                            onChange={handleImageChange}
                            id={inputId}
                        />
                    </label>
                </div>
                <img
                    className="custom_img img-fluid actor_profile modal_placeholder_image"
                    src={imageSrc}
                    alt="Preview"
                />
            </div>
            {sizeError ? (
                <small style={{ color: '#f82541', fontSize: '11px', marginTop: '5px', display: 'block' }}>
                    ⚠ {sizeError}
                </small>
            ) : hint ? (
                <small style={{ color: 'rgba(255,255,255,0.38)', fontSize: '11px', marginTop: '5px', display: 'block' }}>
                    {hint}
                </small>
            ) : null}
        </div>
    );
});

CustomImageBox.displayName = 'CustomImageBox';

export default CustomImageBox;
